import React, { type ComponentProps } from 'react';
import { AutoSavedSelectControl } from '@piwikpro/ui-components';
import styles from './PermissionSelect.module.css';

type SelectOptions = ComponentProps<typeof AutoSavedSelectControl>['options'];

interface PermissionSelectProps {
  initialValue: string
  options: SelectOptions
  onSubmit: (values: { permission: string }, api: { setSubmitting: (value: boolean) => void, resetForm: () => void }) => void
  name?: string
  disabled?: boolean
  dataId?: string
}

export function PermissionSelect({
  initialValue,
  options,
  onSubmit,
  name = 'permission',
  disabled,
  dataId,
}: PermissionSelectProps) {
  return (
    <div className={styles.permissionSelect}>
      <AutoSavedSelectControl
        type="subdued"
        hideTooltip
        name={name}
        dataId={dataId}
        initialValue={initialValue}
        options={options}
        onSubmit={onSubmit}
        disabled={disabled}
      />
    </div>
  );
}
